module.exports = __webpack_public_path__ + "images/emoji/princess.619b710239c73ac583ac.png";